import React from 'react'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import ServiceOrderLoader from '../_load/ServiceOrderLoader'
import ServiceOrderLoaderCertify from '../_load/ServiceOrderLoaderCertify'

const BioqualynetAetPdfPagePdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <ServiceOrderLoaderCertify>
          <PageHeader templateId={parseInt(templateId)} />
          <PageContent />
        </ServiceOrderLoaderCertify>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default BioqualynetAetPdfPagePdfPage
